import React, { useEffect, useState} from "react";
import { Input, Layout, Space, Spin, Typography, Card, Button, List, Select, Divider } from "antd";
import { PlusOutlined, EditFilled, DeleteOutlined } from "@ant-design/icons"
import { utilities } from "../../utilities/utlities";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Link, useParams } from 'react-router-dom';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import api from './api'
import { useNavigator } from "../../utilities/navigation";
import './styles.css'

const Invite = (props) =>{
    const { Content } = Layout
    const { Text } = Typography
    const { Option } = Select
    const [user] = useState(utilities.loggedUser)
    const [navigator] = useNavigator()
    const {data, error, isError, isLoading } = api.useTemplates('invite',user.jwtToken)
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [inputs, setInputs] = useState([])
    const inviteMutation = api.useInvite() 
    const templateMutation = api.useTemplate() 
    const [subject, setSubject] = useState('')
    const [body, setBody] = useState('')
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("contact_email");
    useEffect(()=>{
        if(data){
            setSelectedTemplate(data[0]?._id)
            setSubject(data[0]?.subject)
            setBody(data[0]?.body)
        }
    },[data])
    useEffect(()=>{
        if(myParam != null){
        setInputs([...inputs,{
            value:myParam,invalid:false
        }])
    }else{
        setInputs([...inputs,{value: '',invalid: false}])
    }

    },[])

    const onSelectedChanged = (value) => {
        let template = data.find(x=>x._id.toString() == value)
        setSubject(template.subject)
        setBody(template.body)
        setSelectedTemplate(template._id)
    }
    const updateInputValues = (index,e) => {
        const { name, value } = e.target;
        const list = [...inputs];
        list[index][name] = value;
        setInputs(list);
    }
    const handleAddInput = () => {
        setInputs([...inputs, { value: "" }]);
    }
    const handleRemoveInput = (index) => {
        const list = [...inputs];
        list.splice(index, 1);
        setInputs(list);
    }
    const onClickSendInvite = () => {
        let submit = true
        let emails = []
        for(var i=0;i<inputs.length;i++){
            if(!utilities.validateEmail(inputs[i].value)){
                submit = false
                inputs[i].invalid = true
            }else{
                inputs[i].invalid = false
                emails.push(inputs[i].value)
            }
            setInputs([...inputs])
        }
        if(submit){
            inviteMutation.mutate({emails: emails,token: user.jwtToken,templateId: selectedTemplate})
        }
    }
    const inviteContact  = (email)=>{
        navigator(`invite?contact_email=${email}`)
    }
    const onClickUpdateTempate = () => {
        let data = {
            subject: subject,
            body: body,
            token: user.jwtToken,
            templateId: selectedTemplate
        }
        templateMutation.mutate(data)
    }
    return(
        <Layout className="layout">
            <Content style={{ padding: "0 100px",display: 'flex',justifyContent: 'flex-start' }} className = "site-layout-content">
                <Text style={{fontSize: 16,fontWeight: 500,color: 'rgba(0,0,0,0.85)'}}>Invite Users</Text>
                {isLoading ? <Spin></Spin> : null}
                <Card style={{ width: '30%' }} className = {inviteMutation.isLoading || isLoading ? 'disabled' : ''}>
                    {inviteMutation.isLoading ? <Spin></Spin> : null}
                    {data && data.length > 1 ? <Space style = {{width: '100%',marginBottom: 20}}>
                        <Text>Choose Template</Text>
                        <Select defaultValue = {data[0]._id} onChange = {(value)=> onSelectedChanged(value)}>
                            {data.map((item)=>{
                                return(
                                    <Option value={item._id}>{item.name.split('-')[1]}</Option>
                                )
                            })}
                        </Select>
                    </Space> : null}
                    <Space direction='vertical' style = {{width: '100%'}}>
                        {inputs.map((item,index)=>{
                            return(
                                <Input.Group key = {index}>
                                    <Input
                                        className = {item.invalid ? 'invalid' : ''}
                                        name = "value"
                                        id = {"value"+index}
                                        value = {item.value}
                                        onChange={(e)=> updateInputValues(index,e)} 
                                        style = {{width: '90%'}} 
                                        placeholder="awais.khan@gmail.com"/> 
                                    <Button  
                                        style = {{width: '10%'}} 
                                        onClick = {()=> handleRemoveInput(index)} 
                                        icon={<DeleteOutlined />}></Button>
                                </Input.Group>
                            )
                        })}
                        <Button onClick = {() => handleAddInput()} icon = {<PlusOutlined />} type = 'default'></Button>
                    </Space>
                        <Divider />
                        {subject && body ? 
                        <div className = {templateMutation.isLoading ? 'disabled' : ''} style={{width: '100%', transition: 'ease-in',marginTop: 10}}>
                        <Space direction = 'vertical' style = {{width: '100%',marginBottom: 20}}>
                            <Text type='secondary'>Subject</Text>
                            <Input value = {subject} onChange = {(e)=> setSubject(e.target.value)}/>
                        </Space>
                        <Space direction = 'vertical' style = {{width: '100%',marginBottom: 20}}>
                            <Text type='secondary'>Body</Text>
                            <CKEditor
                                editor = { ClassicEditor }
                                data = {body}
                                onChange = {(e,editor)=>{
                                    setBody(editor.getData())
                                }}
                            />
                        </Space>
                    </div> : null}
                    <div style = {{display: 'flex',marginTop: 10,justifyContent: 'space-between',width: '100%'}}>
                        <Button loading = {templateMutation.isLoading} onClick = {onClickUpdateTempate} type = 'default'>Update Template</Button>
                        <Button loading = {inviteMutation.isLoading} onClick={onClickSendInvite} type='primary'>Send</Button>
                    </div>
                </Card>
                {/* <Text style={{fontSize: 16,fontWeight: 500,color: 'rgba(0,0,0,0.85)'}}>Templates</Text>
                <Card style={{width: '30%'}}>
                    <List
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={item => (
                        <List.Item
                            actions = {[<Button onClick={()=> {
                                setSelectedTemplate(item._id)
                                setSubject(item.subject)
                                setBody(item.body)
                            }} style = {{border: 'none',boxShadow: 'none'}} icon = {<EditFilled />} />]}
                        >
                            <List.Item.Meta
                                title={item.name.split('-')[1]}
                            />
                        </List.Item>
                        )}
                    />
                </Card>
                 */}
            </Content>
        </Layout>
    )
}
export default Invite